import { AirwayConstants } from '../store/airway.constants'

export const airwaySchemas = [
  {
    inputKey: AirwayConstants.SET_FLOW,
    isNumber: true,
    type: 'object',
    properties: {
      SET_FLOW: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_FLOW_(FOR_OXYGEN)'],
  },
  {
    inputKey: AirwayConstants.SET_FIO2,
    isNumber: true,
    type: 'object',
    properties: {
      SET_FIO2: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_FIO2'],
  },
  {
    inputKey: AirwayConstants.SET_HUMIDITY,
    isNumber: true,
    type: 'object',
    properties: {
      SET_HUMIDITY: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_HUMIDITY'],
  },
  {
    inputKey: AirwayConstants.SET_AIR_TEMPERATURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_AIR_TEMPERATURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_AIR_TEMPERATURE'],
  },
  {
    inputKey: AirwayConstants.SET_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_PRESSURE'],
  },
  {
    inputKey: AirwayConstants.SET_INSPIRATORY_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_INSPIRATORY_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_INSPIRATORY_PRESSURE'],
  },
  {
    inputKey: AirwayConstants.SET_EXPIRATORY_PRESSURE,
    isNumber: true,
    type: 'object',
    properties: {
      SET_EXPIRATORY_PRESSURE: {
        type: 'number',
        minimum: 0.1,
        maximum: 999.9,
      },
    },
    additionalProperties: false,
    required: ['SET_EXPIRATORY_PRESSURE'],
  },
  {
    inputKey: AirwayConstants.SET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DATE'],
    errorMessage: {
      properties: {
        SET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: AirwayConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
]

export const airwaySecondsSchemas = [
  {
    inputKey: AirwayConstants.SET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TIME'],
    errorMessage: {
      properties: {
        SET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
